// Fundraise Up — the English page's USD checkout. Their script opens a checkout
// modal over our page; the donation, the receipt and the report to the client
// all happen on their side, so nothing here touches our server or Gramsci.
//
// Account and campaigns are American Friends of Standing Together's, read off
// their dashboard (dashboard.fundraiseup.com/AEYAJKBQ) on 2026-10-14:
//   once    FUNJNDZJXQH  "Website General Donations - Dollars"
//   monthly FUNNEUZSKJZ  "Website FOST Recurring Donations - Dollars" (monthly only)
// The same two campaigns back the Wix page's ?form= links.

import { resolvePurchaseValue, trackPurchase } from './analytics';

const ACCOUNT = 'AEYAJKBQ';

export const FUNDRAISE_UP_CAMPAIGNS = {
  once: 'FUNJNDZJXQH',
  monthly: 'FUNNEUZSKJZ',
};

// Their installation snippet (Settings → Installation), unminified. It defines
// a queueing stub on window.FundraiseUp at once, so openCheckout can be called
// before the real widget has loaded — the call runs when it arrives.
export function loadFundraiseUp() {
  const w = window;
  if (w.FundraiseUp) return;
  const methods = ['call', 'catch', 'on', 'once', 'set', 'then', 'track', 'openCheckout'];
  const stub = function queue(name) {
    return typeof name === 'function'
      ? stub.l.push([arguments]) && stub
      : function queued() { return stub.l.push([name, arguments]) && stub; };
  };
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://cdn.fundraiseup.com/widget/${ACCOUNT}`;
  // The checkout is the payment itself, not a tracker: tell Cookiebot's
  // auto-blocking (index.html) to leave it alone, or a visitor who hasn't
  // answered the cookie banner couldn't donate in dollars at all.
  script.setAttribute('data-cookieconsent', 'ignore');
  const first = document.getElementsByTagName('script')[0];
  if (first && first.parentNode) first.parentNode.insertBefore(script, first);
  else document.head.appendChild(script);
  stub.s = Date.now();
  stub.v = 5;
  stub.h = w.location.href;
  stub.l = [];
  methods.forEach((m) => { stub[m] = stub(m); });
  w.FundraiseUp = stub;
  // Queued like openCheckout, so it's registered before the widget arrives.
  stub.on('donationComplete', reportFundraiseUpDonation);
}

// A completed Fundraise Up donation, reported to the same trackers as the
// IsraelGives pages (DonatePage et al.): Meta Pixel, the Ads conversion and the
// GTM purchase event. Their checkout is third-party, so this is the only signal
// we get that a donation happened. `donation.amount` is the total charged, fee
// included, in the currency picked at checkout. Test-mode checkouts
// (`livemode` false) are skipped so they can't pollute the real numbers.
export function reportFundraiseUpDonation(details) {
  if (!details || details.livemode === false || !details.donation) return;
  const { id, amount, currency } = details.donation;
  const value = resolvePurchaseValue(amount, 0);
  const paidCurrency = currency || 'USD';
  if (window.fbq) window.fbq('track', 'Purchase', { value, currency: paidCurrency });
  if (window.gtag) {
    window.gtag('event', 'conversion', { send_to: 'AW-718777808/kPpUCPHXhu0bENDb3tYC', transaction_id: id || '' });
  }
  trackPurchase({ transactionId: id, value, currency: paidCurrency });
}

// Open the USD checkout for the chosen frequency.
export function openFundraiseUpCheckout(recurring) {
  loadFundraiseUp();
  window.FundraiseUp.openCheckout(recurring ? FUNDRAISE_UP_CAMPAIGNS.monthly : FUNDRAISE_UP_CAMPAIGNS.once);
}
